<template>
  <v-app id="inspire" class="bodyPadding pricelistsScreen"> 
    <mo-header></mo-header>
    <v-content>
		<pricelist-head></pricelist-head>		
		<pricelist-list></pricelist-list>
    </v-content>
  </v-app>
</template>

<script>

	import PricelistHead from './Header.vue';	
	import PricelistList from './List.vue';	
	import { mapGetters } from 'vuex'; 
	
	export default {
		data () {
			return {
		
			}		
		},
		components: {
          PricelistHead,		
          PricelistList
		},
		computed: {
			...mapGetters([			
				'objAuthorize',
			])
		},
		created() {
			if( this.objAuthorize.privileges.indexOf('VIEW_PRICELISTS') === -1 ) {
				this.$router.replace('/');
			}			
		}	
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>